import { PaginatedResult } from "../types/PaginatedResult";
import SandboxDefinition from "../types/SandboxDefinition";
import { SandboxResult } from "../types/SandboxResult";
import { SingleResult } from "../types/SingleResult";
import { httpDelete, httpGet, httpPost } from "./api.service";

const getSandboxItems = async (): Promise<SingleResult<PaginatedResult<SandboxDefinition>>> => 
  await httpGet<SingleResult<PaginatedResult<SandboxDefinition>>>(`api/sandbox`);

const runSandbox = async (contents: string): Promise<SingleResult<SandboxResult>> =>
  await httpPost(`api/sandbox/run`, contents);

const runSandboxForId = async (id: string): Promise<SingleResult<SandboxResult>> =>
  await httpGet(`api/sandbox/${id}/run`);

const saveSandbox = async (sandbox: SandboxDefinition): Promise<SingleResult<SandboxDefinition>> =>
  await httpPost(`api/sandbox`, sandbox);

const deleteSandbox = async (id: string): Promise<SingleResult<void>> =>
  await httpDelete(`api/sandbox/${id}`);

export { getSandboxItems, runSandbox, runSandboxForId, saveSandbox, deleteSandbox }